import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { AppPermissions } from '@core/bff/app-permissions';
import { AuthenticationService } from '@core/services/authentication.service';
import { catchError, map, of, Subscription } from 'rxjs';

@Pipe({
    name: 'permission',
    pure: false,
    standalone: true,
})
export class PermissionPipe implements PipeTransform, OnDestroy {
    private authentication = inject(AuthenticationService);
    private cd = inject(ChangeDetectorRef);
    private subscription?: Subscription;
    private key?: string;
    private latestValue: boolean | null = null;

    transform(key: keyof AppPermissions): boolean | null {
        if (!this.key) {
            if (key) {
                this.subscribe(key);
            }

            return this.latestValue;
        }

        if (key !== this.key) {
            this.dispose();
            return this.transform(key);
        }

        return this.latestValue;
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.dispose();
        }
    }

    private dispose() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    }

    private subscribe(key: keyof AppPermissions) {
        this.subscription = this.authentication.permissions$
            .pipe(
                map((permissions) => permissions?.[key]),
                catchError(() => of(false)),
            )
            .subscribe((value) => {
                this.latestValue = value as boolean;
                this.cd?.markForCheck();
            });
    }
}
